import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Modal, Button } from 'advenio-components'
import CreditCardPreview from '../CreditCardPreview'

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin: 16px;
`
const ButtonsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  align-self: flex-end;
  flex: 1;
  margin-top: 32px;
`
const Message = styled.div`
  margin-top: 16px;
`

const AuthorizeModal = ({
  card,
  isBeingAuthorized,
  isOpen,
  isSmallScreen,
  loading,
  onAuth,
  onClose,
  onUnauth,
  parent,
  student,
}) => {
  const getTitle = () => {
    if (isSmallScreen) return '¿Revocar tarjeta?'

    return '¿Revocar autorización de tarjeta?'
  }

  return (
    <Modal
      isOpened={isOpen}
      onClose={onClose}
      headerTitle={isBeingAuthorized ? '¿Autorizar Tarjeta?' : getTitle()}
      statePath="cards"
      actionType="auth"
      typePrefix="CARDS"
      smallHeader={isSmallScreen}
    >
      <Container>
        {parent && (
          <CreditCardPreview card={card} parentName={`${parent.first_name} ${parent.last_name_paternal}`} />
        )}
        <Message>
          ¿Estás seguro que deseas {isBeingAuthorized ? 'autorizar' : 'revocar la autorización de'} esta tarjeta para uso de <b>{`${student.first_name} ${student.last_name_paternal}`}</b>?
        </Message>
        <ButtonsContainer>
          <Button
            ghost
            onClick={onClose}
          >
            Cancelar
          </Button>
          <Button
            primary={isBeingAuthorized}
            danger={!isBeingAuthorized}
            loading={loading}
            onClick={isBeingAuthorized ? onAuth : onUnauth}
          >
            {isBeingAuthorized ? 'Autorizar Tarjeta' : 'Desautorizar Tarjeta' }
          </Button>
        </ButtonsContainer>
      </Container>
    </Modal>
  )
}

AuthorizeModal.propTypes = {
  /** The credit card being authorized/deauthorized */
  card: PropTypes.object,
  /** Indicates whether the credit card is being authorized or deauthorized */
  isBeingAuthorized: PropTypes.bool,
  /** Indicates whether the modal should be displayed or hidden */
  isOpen: PropTypes.bool,
  /** Indicates whether the modal is being displayed full-screen on a mobile device */
  isSmallScreen: PropTypes.bool,
  /** Indicates whether an API call is in progress */
  loading: PropTypes.bool,
  /** The active parent */
  parent: PropTypes.object.isRequired,
  /** The active student */
  student: PropTypes.object.isRequired,
  /** Callback function to be fired when authorizing the specified credit card */
  onAuth: PropTypes.func,
  /** Callback function to be fired when closing the modal */
  onClose: PropTypes.func.isRequired,
  /** Callback function to be fired when deauthorizing the specified credit card */
  onUnauth: PropTypes.func,
}

AuthorizeModal.defaultProps = {
  isBeingAuthorized: true,
  isOpen: false,
  isSmallScreen: false,
  loading: false,
  onAuth: () => {},
  onUnauth: () => {},
}

export default AuthorizeModal



// WEBPACK FOOTER //
// ./src/Components/ProfileViews/AuthorizeModal.jsx